import React from "react";
import HeaderImg from "../../../../assets/img/attarImg.jpg";
import { useAuth } from "../../../../contexts/AuthContext";
import { Link } from "react-router-dom";
import { panelPath } from "../../../../auth/session";
import useReveal from "../../../../hooks/useReveal";
import { Shell } from "../../../shares/landing/LandingWidgets";

/**
 * Asymmetric public-facing hero using the same accent wash, panel edges and
 * restrained motion as the redesigned dashboards. Copy and auth flow are
 * unchanged.
 */
const Header = ({ onLoginOpen }) => {
  const { session } = useAuth();
  const [heroRef, heroIn] = useReveal({ threshold: 0.05 });

  const ctaClass =
    "landing-cta inline-flex items-center justify-center rounded-soft bg-primary px-3xl py-md text-md font-medium text-ink-inverse shadow-card transition-colors duration-200 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-canvas motion-reduce:transition-none";

  return (
    <section
      id="header"
      ref={heroRef}
      className={`${heroIn ? "in-view" : ""} landing-hero`}
    >
      <Shell>
        <div className="grid items-center gap-4xl lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:gap-5xl">
          <div className="relative z-[1] min-w-0 py-xl lg:py-4xl">
            <h1
              className="reveal reveal--up max-w-[11ch] text-6xl font-black leading-[1.2] tracking-[-0.035em] text-ink-strong max-sm:text-4xl"
              style={{ "--i": 0 }}
            >
              <span className="text-primary">ریاضیات</span> متوسطه دوم
            </h1>

            <p
              className="reveal reveal--up mt-2xl max-w-[58ch] text-lg font-light leading-[2.15] text-ink-muted"
              style={{ "--i": 1 }}
            >
              ریاضی کنکور با سرفصل‏ هایی چون تابع، مثلثات، حد، مشتق و ... شناخته می
              ‏شود. شاید ریاضی بیش از هر درس دیگری نیازمند عمیق شدن و درک ‏کردن دقیق
              مفاهیم باشد. در حقیقت اگر ریاضی خوب فهمیده شود، روند حل یک مسئله
              معمولاً آسان‏ تر از آن خواهد بود که نیاز داشته باشیم درگیر انواع روش‏
              های تستی و راه ‏های میان ‏بر شویم.
              <br />
              <br />
              با یک نگاه واقع ‏بینانه باید گفت، مهم ‏تر از هر کتاب و کلاس و مؤلف و
              معلمی، این «تلاش» یک دانش‏ آموز است که موفقیت نهایی وی را در ریاضی -و
              البته سایر دروس- حاصل می ‏کند.
            </p>

            <div className="reveal reveal--up mt-3xl" style={{ "--i": 2 }}>
              {session ? (
                <Link
                  to={panelPath(session)}
                  className={ctaClass}
                >
                  {session.user.role === "student" ? "پنل دانش آموز" : "پنل مدیریت"}
                </Link>
              ) : (
                <button
                  type="button"
                  onClick={onLoginOpen}
                  className={ctaClass}
                >
                  ورود به سامانه
                </button>
              )}
            </div>
          </div>

          <div
            className="reveal reveal--left relative min-w-0 max-lg:order-first"
            style={{ "--i": 0 }}
          >
            <div className="landing-hero__media">
              <div className="overflow-hidden rounded-wide">
                <img
                  src={HeaderImg}
                  alt="آموزشگاه ریاضی مهندس عطار"
                  className="aspect-[4/3] w-full object-cover shadow-headerCard transition-transform duration-500 hover:scale-[1.015] motion-reduce:transition-none"
                />
              </div>
            </div>
          </div>
        </div>
      </Shell>

    </section>
  );
};

export default Header;
